<template>
<v-app id="inspire">
  <v-content class="teal darken-3">
    <div style="text-align: -webkit-center" class="teal darken-3">
      <v-card class="mt-5" width="50%">
        <v-card-title>
          Masukkan Tanggal
        </v-card-title>
        <v-card-text>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="inputDate"
                label="Tanggal"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="inputDate" @change="onCekDaftarHadir" @input="menu = false"></v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
        <p class="display-1 font-weight-light mt-5 white--text">Daftar Hadir</p>
        <p class="subtitle font-weight-light mb-0 white--text">Total User: {{ getTotalCheckIn() }} orang</p>
        <p class="subtitle font-weight-light white--text">Total Kunjungan: {{ getTotalUser() }} orang</p>
        <template>
            <div class="ma-5">
                <v-data-table
                    :headers="headers"
                    :items="listCheckIn"
                    show-expand
                    :single-expand="true"
                    class="elevation-1"
                    color="green lighten-1"
                >
                  <template v-slot:[`item.no`]="{ item }">
                    {{(listCheckIn.indexOf(item)+1) + '.'}}
                  </template>
                  <template v-slot:[`item.checkIn`]="{ item }">
                    <template>
                      {{ getAttendance(item.checkIn) }}
                    </template>
                  </template>
                  <template v-slot:[`expanded-item`]="{ headers, item }">
                    <td :colspan="headers.length" class="px-6 pt-2 pb-6">
                      <div class="text-center pa-2"><span class="title">Daftar Hadir</span></div>
                      <template v-if="item.checkIn.length > 0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead class="grey grey lighten-2">
                              <tr>
                                <th class="text-left">
                                  No.
                                </th>
                                <th class="text-left">
                                  Nama
                                </th>
                                <th class="text-left">
                                  Telepon
                                </th>
                                <th class="text-left">
                                  Jam Masuk
                                </th>
                                <th class="text-left">
                                  Jam Keluar
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in item.checkIn"
                                :key="data.id+'-'+index"
                                >
                                <td>{{index+1}}.</td>
                                <td>{{ data.name }}</td>
                                <td>{{ data.telp }}</td>
                                <td>{{ data.checkInTime }}</td>
                                <td>{{ data.checkOutTime }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </template>
                      <template v-else><div class="text-center"><span>No data available.</span></div></template>
                    </td>
                  </template>
                </v-data-table>
            </div>
        </template>
    </div>
  </v-content>
  <v-snackbar style="z-index: 9999"
    :top='true'
    v-model='snackbar.visible'
    :color='snackbar.color'
    :timeout='snackbar.timeout'
    :multi-line='snackbar.multiline'
  >{{snackbar.text}}</v-snackbar>
</v-app>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find, uniqBy } from "lodash";
import moment from 'moment';
import firebase from "../firebaseConfig.js";
const db = firebase.database();
export default {
  name: "CheckIn",
  components: {
  },
  data() {
    return {
      menu: false,
      inputDate: null,
      listCheckIn: [],
      headers: [
          {
            text: 'No.',
            align: 'start',
            value: 'no',
            class: 'white--text'
          },
          {text: 'Submission Name',value: 'item.submission.name',class: 'white--text'},
          {text: 'Customer Name',value: 'item.submission.customer.name',class: 'white--text'},
          {
            text: 'Services',
            align: 'start',
            value: 'item.item_name',
            class: 'white--text'
          },
          {text: 'Start',value: 'start',class: 'white--text'},
          {text: 'Finish',value: 'finish',class: 'white--text'},
          {text: 'Jumlah Hadir',value: 'checkIn',class: 'white--text',align: 'center'},
          {text: '', value: 'data-table-expand' }
      ],
      headerSubItems: [
          {
            text: 'No.',
            align: 'start',
            value: 'no',
            class: 'white--text'
          },
          {text: 'Nama',value: 'nama',class: 'white--text'},
          {text: 'Telepon',value: 'telepon',class: 'white--text'},
          {text: 'Masuk',value: 'masuk',class: 'white--text'},
      ],
    };
  },
  computed: {
      ...mapGetters({
      }),
      ...mapState({
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      closeLoading: "closeLoading",
    }),
    ...mapActions({
      cekJadwal: "jadwal/cekJadwal"
    }),
    getTotalCheckIn(){
        let tempItem = []
        forEach(this.listCheckIn, items => {
          forEach(items.checkIn, item => {
            tempItem.push(item)
          })
        })

        tempItem = uniqBy(tempItem, 'id')
        return tempItem.length;
    },
    getTotalUser(){
        let tempItem = []
        forEach(this.listCheckIn, items => {
          forEach(items.checkIn, item => {
            tempItem.push(item)
          })
        })

        return tempItem.length;
    },
    getAttendance(items){
        let tempItem = []
        forEach(items, item => {
          tempItem.push(item)
        })

        tempItem = uniqBy(tempItem, 'id')
        return tempItem.length;
    },
    async initialize(){
      const companyId = JSON.parse(window.localStorage.getItem('company')).id
      this.inputDate = moment().format('YYYY-MM-DD')
      let attendanceRefs = db.ref('Attendance-'+companyId+'-'+process.env.VUE_APP_ENV)

      attendanceRefs.child(this.inputDate).once('value', (snap) => {
        if(snap.val()){
          this.listCheckIn = snap.val()
          this.listCheckIn.forEach(list => {
            if(!list.checkIn){
              list.checkIn = []
            }
          })
        }
      });
    },
    onCekDaftarHadir(){
      const companyId = JSON.parse(window.localStorage.getItem('company')).id
      let attendanceRefs = db.ref('Attendance-'+companyId+'-'+process.env.VUE_APP_ENV)
      attendanceRefs.child(this.inputDate).once('value', (snap) => {
        this.listCheckIn = []
        if(snap.val()){
          this.listCheckIn = snap.val()
          this.listCheckIn.forEach(list => {
            if(!list.checkIn){
              list.checkIn = []
            }
          })
        }
      });
    }
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>